import React, { createContext, useContext } from 'react';

/**
 * Contesto che rende i componenti LEAD 2.0 riutilizzabili sia nell'area Admin
 * sia nel Portale Agente. Fornisce token, ruolo, path base, utente corrente e Layout.
 */
const Leads2PortalContext = createContext({
  token: null,
  role: 'admin', // 'admin' | 'agent'
  basePath: '/admin/leads2',
  currentUserId: null,
  currentUserName: null,
  Layout: ({ children }) => <>{children}</>,
});

export const useLeads2Portal = () => useContext(Leads2PortalContext);

export const Leads2PortalProvider = ({ value, children }) => (
  <Leads2PortalContext.Provider value={value}>{children}</Leads2PortalContext.Provider>
);

export default Leads2PortalContext;
